module.exports = __webpack_public_path__ + "static/media/business-office1.3c0e379a.png";